import { useQuery } from "@tanstack/react-query";
import { fetchCategoryGoods } from "@/lib/services/appointmentModalService";

/**
 * Hook to fetch goods for a specific category.
 * @param categoryId - The category ID to fetch goods for
 */
export function useCategoryGoods(categoryId: number | null) {
    return useQuery({
        queryKey: ["categoryGoods", categoryId],
        queryFn: () => fetchCategoryGoods(categoryId!),
        enabled: !!categoryId && categoryId > 0,
        staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    });
}
